"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadToS3 = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _clientS = require("@aws-sdk/client-s3");
var _requestHandler = require("./request-handler");
// const s3 = require('s3')

//key account bmd (aws) info@bmd.com.vn
var accessKeyId = "AKIAXMCIVKABQTCEKIFV";
var secretAccessKey = "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";
var bucketName = "050-shipping";
var myHttpHandler = new _requestHandler.MyHttpHandler();
var client = new _clientS.S3Client({
  credentials: {
    accessKeyId: accessKeyId,
    secretAccessKey: secretAccessKey
  },
  region: "ap-southeast-1",
  requestHandler: myHttpHandler
});
var uploadToS3 = exports.uploadToS3 = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(file, key, onProgress, onDone) {
    var contentType,
      _args = arguments;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          contentType = _args.length > 4 && _args[4] !== undefined ? _args[4] : "video/mp4";
          return _context.abrupt("return", new Promise(function (resolve, reject) {
            var target = {
              Bucket: bucketName,
              Key: key,
              Body: file,
              ContentType: contentType
            };
            myHttpHandler.onProgress$.subscribe(function (progress) {
              var percentComplete = progress.progressEvent.loaded / progress.progressEvent.total * 100;
              onProgress(percentComplete);
            });
            client.send(new _clientS.PutObjectCommand(target)).then(function (data) {
              console.log(" // process data.", data);
              onDone();
              resolve(data);
            });
          }));
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function uploadToS3(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();